
import {findAcessoPorRecursoPerfil} from "@/api/gestaoAcesso";

export default {
  name: "GlobalMixin",
  methods: {
    async getPermissaoPorItemPerfil(item, perfil) {
      try {
        const page = await findAcessoPorRecursoPerfil(item, perfil);
        let tamanhoArray = page.dados.length;
        return tamanhoArray > 0;
      } catch (err) {
        return false;
      }
    },
    isFornecedorOuComprador(perfil){
      return (["FOR","COM"].includes(perfil));
    } 
  },
};